import { TimeOffAccrualPeriodEnum, TimeoffAccrualWaitingPeriod, TimeoffCarryOverRule } from "../../enums";
import { Milestone, Timeoff } from "../model";

export interface TimeOffBalance {
    type: string;
    used: string;
    available?: string;
    icon: React.ReactNode;
}

export interface RequestFormData {
    note: string;
    category_code: string;
    details: RequestTimeDataValue[];
}

export type RequestTimeData = Record<string, RequestTimeDataValue>;

export type RequestTimeDataValue = {
    date: string;
    start_time?: string | null;
    end_time?: string | null;
    amount: string;
    use_time_range?: boolean;
    duration_type?: "HOURS" | "TIME_RANGE" | "FULL_DAY" | "HALF_DAY";
};

export interface DatePickerStepProps {
    selectedDates: Date[];
    setSelectedDates: React.Dispatch<React.SetStateAction<Date[]>>;
    onNext: () => void;
    isUpdateMode: boolean;
    timeoffToUpdate?: Timeoff
}

export interface RequestFormStepProps {
    formData: RequestFormData;
    setFormData: React.Dispatch<React.SetStateAction<RequestFormData>>;
    selectedDates: Date[];
    onBack: () => void;
    onSubmit: (data: any) => void; // Update onSubmit to accept form data and timeData
    isUpdateMode: boolean;
    timeoffToUpdate?: Timeoff
}

export const TimeoffAccrualTitle = { 
    [TimeOffAccrualPeriodEnum.DAILY]: "Daily",
    [TimeOffAccrualPeriodEnum.WEEKLY]: "Weekly",
    [TimeOffAccrualPeriodEnum.MONTHLY]: "Monthly",
    [TimeOffAccrualPeriodEnum.YEARLY]: "Yearly",
    [TimeOffAccrualPeriodEnum.ON_ANNIVERSARY]: "On anniversary",
}

export const TimeoffAccrualWaitingPeriodTitle = {
    [TimeoffAccrualWaitingPeriod.MONTHS]: "Months",
    [TimeoffAccrualWaitingPeriod.YEARS]: "Years",
    [TimeoffAccrualWaitingPeriod.DAYS]: "Days",
}

export const TimeoffCarryOverRuleTitle= {
    [TimeoffCarryOverRule.UNLIMITED]: "Unlimited",
    [TimeoffCarryOverRule.UPTO]: "Up to...",
}

export interface MilestoneFormProps {
    milestone: Milestone;
    onRemove: (order: number) => void;
    onSave: (milestone: Milestone) => void;
    // removeMilestone: (id: number) => void;
    // handleChange: (id: number, field: string, value: any) => void;
    // handleCapChange: (id: number, value: string) => void;
    // handleCarryoverChange: (id: number, value: string) => void;
    // capSelected: Record<number, boolean>;
    // carryoverSelected: Record<number, boolean>;
}